import { render, staticRenderFns } from "./organization-question-set-answering.vue?vue&type=template&id=fa39fa84&scoped=true"
import script from "./organization-question-set-answering.vue?vue&type=script&lang=js"
export * from "./organization-question-set-answering.vue?vue&type=script&lang=js"
import style0 from "./organization-question-set-answering.vue?vue&type=style&index=0&id=fa39fa84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa39fa84",
  null
  
)

export default component.exports